import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { hasMarketplaceSelector } from 'store/selectors/organizationSelectors/orgSettingsSelector';
import isUserAgencySelector from 'store/selectors/userSelectors/isUserAgencySelector';
import isUserEssentialSelector from 'store/selectors/userSelectors/isUserEssentialSelector';

const canManageSkillsSelector = createSelector(
  [isUserAgencySelector, isUserEssentialSelector, hasMarketplaceSelector],
  (isUserAgency, isUserEssential, hasMarketplace) =>
    !isUserAgency && !isUserEssential && !hasMarketplace,
);

export const useCanManageSkillsSelector = () => useSelector(canManageSkillsSelector);

export default canManageSkillsSelector;
